import { observer } from "mobx-react-lite/dist"
import useStore from "reusable/mobx-store-utils"
import CreateClientContactAutocompleteStore, { CreateClientContactAutocompleteStoreProvider } from "./CreateClientContactAutocompleteStore"
import GapAutocompleteMultiple from "features/gap-components/autocomplete/multiple/GapAutocompleteMultiple"
import CreateClientContactModal from "features/clients/create/contact/CreateClientContactModal"
import { GapAutocompleteOption } from "features/gap-components/autocomplete/types/GapAutocompleteTypes"
import SkeletonLoader from "reusable/mui/skeleton/SkeletonLoader"
import { AdvisorClientContactDto } from "@gap/backend/app-services/advisor/client/contact/models/AdvisorClientContactDto"
import { useEffect } from "react"

export interface CreateClientContactAutocompleteParams {
   id?: string
   label?: string
   value: string[]
   advisorClientId: string
   clientUsers?: GapAutocompleteOption[] // optional list of client users
   onChange: (contactIds: string[], advisorContact?: AdvisorClientContactDto.entity) => void
   dontFetchContacts?: boolean
}

export default observer(function CreateClientContactAutocomplete(props: CreateClientContactAutocompleteParams) {
   const createClientContactAutocompleteStore = useStore((sp) => new CreateClientContactAutocompleteStore(sp), { advisorClientId: props.advisorClientId, onChange: props.onChange, clientUsers: props.clientUsers, value: props.value, dontFetchContacts: props.dontFetchContacts })

   useEffect(() => {
      createClientContactAutocompleteStore.fetch()
   }, [createClientContactAutocompleteStore])

   return <CreateClientContactAutocompleteStoreProvider store={createClientContactAutocompleteStore}>
      <SkeletonLoader loading={createClientContactAutocompleteStore.loader.isLoading}>
         {createClientContactAutocompleteStore.formHandler.userIds.bindInput(ip =>
            <GapAutocompleteMultiple
               {...ip}
               id={props.id || "create-contact-autocomplete"}
               onNewOption={createClientContactAutocompleteStore.onCreateClientContactClickHandler}
               options={createClientContactAutocompleteStore.userOptions}
               label={`${!!props.label ? props.label : 'Contacts'}`}
               autoFocus
               disableCloseOnSelect
               onChange={createClientContactAutocompleteStore.onContactIdsChange}
            />
         )}
      </SkeletonLoader>

      {createClientContactAutocompleteStore.showCreateClientContactModal && <CreateClientContactModal advisorClientId={props.advisorClientId} />}
   </CreateClientContactAutocompleteStoreProvider>
})
